// src/pages/Blog.jsx
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import blogData from '../data/blogData';
import '../styles/Blog.css';

const Blog = () => {
  useEffect(() => {
    document.title = 'Blog | Bularis Tech';
  }, []);

  return (
    <div className="blog">
      <div className="blog-header">
        <h1>Blog</h1>
        <p>Stay updated with our latest posts and articles.</p>
      </div>
      <div className="blog-posts">
        {blogData.map((post) => (
          <div key={post.id} className="blog-post">
            <h2>{post.title}</h2>
            <p>{post.description}</p>
            <Link to={`/blog/${post.id}`}>Read More →</Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;